import { useEffect, useRef } from 'react'
import { useFormikContext } from 'formik'

import { useTimeZone } from '../../../../hooks'
import { FormModalBody } from '../../../Form'
import { useCalendarDayLoad } from '../../Calendar.hooks'
import {
  getCalendarRelieveDayTargetLoadParams,
  getIsCalendarRelieveDayLoading,
  getIsCalendarRelieveDayPending,
} from '../CalendarRelieveDayModal.utils'

function CalendarRelieveDayModalBody({
  actionsProps,
  formFieldsProps,
  ...restProps
}) {
  const timezone = useTimeZone()

  const { values } = useFormikContext()

  const cancelRef = useRef(null)

  const isLoading = getIsCalendarRelieveDayLoading(formFieldsProps.nextFreeDay)

  const targetLoad = useCalendarDayLoad(
    getCalendarRelieveDayTargetLoadParams({
      day: formFieldsProps.day,
      followUps: formFieldsProps.followUps,
      timezone,
      values,
    })
  )

  useEffect(() => {
    cancelRef.current?.focus()
  }, [])

  return (
    <FormModalBody
      {...restProps}
      actionsProps={{
        ...actionsProps,
        cancelProps: { ...actionsProps.cancelProps, elementRef: cancelRef },
        isPending: getIsCalendarRelieveDayPending({ isLoading, targetLoad }),
      }}
      formFieldsProps={{ ...formFieldsProps, isLoading, targetLoad }}
    />
  )
}

export default CalendarRelieveDayModalBody
